<template>
  <div id="app">
    <transition name="view" mode="out-in">
      <router-view />
    </transition>
    <portal-target name="popup" multiple />
  </div>
</template>

<script>
import store from '@/store'

export default {
  store,
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background-color: hsl(0, 0%, 98%);
}
* {
  user-select: none;
}
input, textarea {
  user-select: text;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.main {
  z-index: 1;
  position: relative;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  color: hsl(200, 1%, 20%);
  background-color: #fff;
  max-width: 750px;
  margin: 0 auto;
  padding: 0 0 72px;
  overflow: hidden;
}

.view-enter-active, .view-leave-active {
  transition: all 200ms ease;
}
.view-enter, .view-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
